import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Image } from '@design-system/image';
import { MediaWrapper } from './MediaWrapper';
import { getAspectRatioForEmbed } from '../utils';
export const MediaContent = ({ aspectRatio: aspectRatioProp, embed, imgUrl, renderEmptyPreview, }) => {
    const [hasError, setHasError] = useState(false);
    const aspectRatio = aspectRatioProp ||
        getAspectRatioForEmbed(hasError ? Object.assign(Object.assign({}, embed), { thumbnail_height: 0, thumbnail_width: 0 }) : embed);
    if (!imgUrl || hasError) {
        return (_jsx(MediaWrapper, { "$aspectRatio": aspectRatio, children: renderEmptyPreview === null || renderEmptyPreview === void 0 ? void 0 : renderEmptyPreview(embed) }));
    }
    return (_jsx(MediaWrapper, { "$aspectRatio": aspectRatio, children: _jsx(Image, { alt: "", "data-testid": "ds-embed-thumbnail", height: "100%", onError: () => setHasError(true), src: imgUrl, style: { aspectRatio, objectFit: 'cover' }, width: "100%" }) }));
};
//# sourceMappingURL=MediaContent.js.map